module.exports = require('./_global');


//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/core-js/modules/_path.js
// module id = 291
// module chunks = 0 3 5